/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundTimeForwardIcon24Regular = forwardRef('ArrowRoundTimeForwardIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M16.044 4.81a8.25 8.25 0 1 0 3.595 10.305.75.75 0 1 1 1.39.566 9.75 9.75 0 1 1-.779-8.877V3.246a.75.75 0 0 1 1.5 0V9a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1 0-1.5h3.849a8.25 8.25 0 0 0-3.305-3.44Z" })));
});
